import css from './index.module.scss';
import Power from './Power';
import Smart from './Smart';
import { useGlobal } from '@/utils/useGlobal';

export default function L() {
    const { useLang } = useGlobal();
    const { t } = useLang('vanlife');
    return (
        <div id="vanlife-L" className={`vanlife-L ${css['vanlife-L']}`}>
            <h2 className="title">{t('secL_title')}</h2>
            <p className="text desc-h2">{t('secL_desc')}</p>
            <Power />
            <Smart />
        </div>
    );
}
